import * as Sentry from '@sentry/react';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const tracesSampleRate = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? 0.1);
const replaysSessionSampleRate = Number(process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0.0);
const replaysOnErrorSampleRate = Number(process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? 1.0);

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,

    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.1,
    tracePropagationTargets: [/^\//, /^https?:\/\/[^/]+\/api/],
    replaysSessionSampleRate: Number.isFinite(replaysSessionSampleRate) ? replaysSessionSampleRate : 0.0,
    replaysOnErrorSampleRate: Number.isFinite(replaysOnErrorSampleRate) ? replaysOnErrorSampleRate : 1.0,
  });
}

export { Sentry };
